import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bi-dashboards',
  templateUrl: './bi-dashboards.component.html',
  styleUrls: ['./bi-dashboards.component.css']
})
export class BiDashboardsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
